/**
 * Placeholder images and utilities for profiles without photos
 */

// Generate a placeholder image URL with initials
export const getProfilePlaceholder = (name, size = 200) => {
  const initials = name
    ? name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '?';
  
  // Use a gradient background with initials
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || 'User')}&size=${size}&background=3B5BA5&color=fff&bold=true&format=svg`;
};

// Cover photo placeholder - a nice gradient
export const getCoverPlaceholder = () => {
  return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400"%3E%3Cdefs%3E%3ClinearGradient id="grad" x1="0%25" y1="0%25" x2="100%25" y2="100%25"%3E%3Cstop offset="0%25" style="stop-color:%233B5BA5;stop-opacity:1" /%3E%3Cstop offset="100%25" style="stop-color:%2360A5FA;stop-opacity:1" /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width="1200" height="400" fill="url(%23grad)" /%3E%3C/svg%3E';
};

// Brand logo placeholder
export const getBrandLogoPlaceholder = (brandName) => {
  const initial = brandName ? brandName[0].toUpperCase() : 'B';
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(brandName || 'Brand')}&size=200&background=3B5BA5&color=fff&bold=true&format=svg`;
};

// Helper function to handle image errors and set placeholder
export const handleImageError = (e, placeholderUrl) => {
  e.target.onerror = null; // Prevent infinite loop
  e.target.src = placeholderUrl;
};

// Get initials from name
export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};
